export const API_HOST = process.env.VUE_APP_API_ENTRYPOINT;
export const API_PATH = '/';



// WEBPACK FOOTER //
// ./src/config/_entrypoint.js